import styles from './index.module.scss';
import React from 'react';
import AiTipIcon from '@/assets/icons/ai-tip.svg?react';
import { Skeleton } from '@/common/base/skeleton';

interface AiSuggestionComponentProps {
  content: string;
  loading?: boolean;
}
/**
 * ai建议
 * @param param0
 * @returns
 */
export const AiSuggestionComponent = (props: AiSuggestionComponentProps) => {
  const { content, loading = false } = props;
  return (
    <div
      className=" border border-[#E3F7EF] rounded-2xl p-4"
      style={{
        background: 'linear-gradient(91deg, rgba(205, 246, 230, 0.20) 26.63%, rgba(255, 245, 195, 0.20) 99.74%)',
      }}
    >
      {loading ? (
        <div>
          <Skeleton className={`h-4 w-1/6 rounded-[4px] ${styles.gradient}`} />
          <Skeleton className={`h-4 w-full rounded-[4px] mt-3 ${styles.gradient}`} />
          <Skeleton className={`h-4 w-5/6 rounded-[4px] mt-[6px] ${styles.gradient}`} />
        </div>
      ) : (
        <React.Fragment>
          <div className="flex items-center gap-2 mb-2">
            <div className=" flex justify-center items-center gap-2  px-2.5 py-1 ">
              <AiTipIcon />
              <span className="text-[#262626] text-xl font-semibold">Suggestion</span>
            </div>
          </div>
          <p className="text-base font-normal text-[#262626]">{content}</p>
        </React.Fragment>
      )}
    </div>
  );
};
